import { render, staticRenderFns } from "./ChooseTemplatesModal.vue?vue&type=template&id=71a2c422&scoped=true"
import script from "./ChooseTemplatesModal.vue?vue&type=script&lang=js"
export * from "./ChooseTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a2c422",
  null
  
)

export default component.exports